import {BLOCKS, INLINES} from '@contentful/rich-text-types'
import {
    AspectRatio,
    Image
} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {EmbeddedEntryBlock} from '../../../../components/rich-text/EmbeddedEntry'
import {HeadingText} from '../../../../components/rich-text/Header'
import {LinkRendererBlogOptions} from '../../../../components/rich-text/LinkRendererBlogOptions'
import {Paragraph} from '../../../../components/rich-text/Paragraph'

const BlogAsset = (node, assetMap) => {
    const asset = assetMap?.get(node.data.target.sys.id)

    if (asset.contentType && asset.contentType === 'video/mp4') {
        return (
            <video width="100%" height="100%" autoPlay muted loop>
                <source src={asset.url} type="video/mp4" />
            </video>
        )
    }

    return (
        <AspectRatio ratio={3 / 1.5}>
            <Image className="img" src={asset.url} objectFit="cover" />
        </AspectRatio>
    )
}

export const blogOptions = (links) => {
    // create an asset & entry map
    const assetMap = new Map()
    const entryMap = new Map()
    // loop through the assets and add them to the map
    const linkBlocks = links.entries.inline || []

    const assetBlocks = links.assets.block || []

    for (const asset of assetBlocks) {
        if (asset.typeName.toLowerCase() === 'asset') {
            assetMap.set(asset.sys.id, asset)
        }
    }
    // loop through the block linked entries and add them to the map
    for (const entry of linkBlocks) {
        if (entry.typeName.toLowerCase() === 'link') {
            entryMap.set(entry?.sys?.id, entry)
        }
    }

    return {
        renderNode: {
            [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
                return EmbeddedEntryBlock(node, children, entryMap)
            },
            ['embedded-entry-inline']: (node, children) => {
                return EmbeddedEntryBlock(node, children, entryMap)
            },
            [INLINES.HYPERLINK]: LinkRendererBlogOptions,
            [BLOCKS.PARAGRAPH]: Paragraph,
            [BLOCKS.EMBEDDED_ASSET]: (node) => BlogAsset(node, assetMap),
            [BLOCKS.HEADING_1]: (node) => HeadingText(node, 'h1'),
            [BLOCKS.HEADING_2]: (node) => HeadingText(node, 'h2'),
            [BLOCKS.HEADING_3]: (node) => HeadingText(node, 'h3'),
            [BLOCKS.HEADING_4]: (node) => HeadingText(node, 'h4'),
            [BLOCKS.HEADING_5]: (node) => HeadingText(node, 'h5'),
            [BLOCKS.HEADING_6]: (node) => HeadingText(node, 'h6')
        }
    }
}
